import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Image from 'yoda-core-components/lib/components/Image/Image';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import energyStarImg from '../../assets/jpg/Energy_Star.jpeg';

class EnergyStar extends Component {
    static defaultProps = {
        energyStar: false,
        staticRoute: '',
    };

    static propTypes = {
        energyStar: PropTypes.bool,
        staticRoute: PropTypes.string,
    };

    render() {
        const { energyStar } = this.props;
        const imageRatio = (energyStarImg.height / energyStarImg.width) * 100;
        return energyStar ? (
            <div className={dt(['w-[39px]', 'h-[39px]', 'my-0', 'mx-auto'])}>
                <Image
                    automationId="energyStar"
                    src={`/${this.props.staticRoute}/assets/jpg/Energy_Star.jpeg`}
                    alt=""
                    imageRatio={imageRatio}
                    aria-label="energyStarlogo"
                />
            </div>
        ) : (
            <div />
        );
    }
}

const mapStateToProps = (state) => ({
    staticRoute: state.context ? state.context.staticRoute : '',
});

export default connect(mapStateToProps)(EnergyStar);
